import i18n from 'i18next';

import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next)
  .init({
    fallbackLng: 'pl',
    debug: true,
    resources:{
        pl: {
            translation: {
                "Don't have an account?": "Nie masz konta?",
                "Already have an account?": "Masz już konto?",
                "Sign up": "Zarejestruj",
                "Log in": "Zaloguj",
                "Email": "Email",
                "Username": "Nazwa użytkownika",
                "Password": "Hasło",
                "Logout": "Wyloguj",
                "Profile": "Profil",
                "Save": "Zapisz",
                "Clone": "Klonuj",
                "Event page": "Strona wydarzenia",
                "Events": "Wydarzenia",
                "votedN_one": "1 głos",
                "votedN_few": "{{count}} głosy",
                "votedN_many": "{{count}} głosów",
                "votedNOutOfM_one": "1 głos / {{total}}",
                "votedNOutOfM_few": "{{count}} głosy / {{total}}",
                "votedNOutOfM_many": "{{count}} głosów / {{total}}",
                "entriesN_one": "1 zgłoszenie",
                "entriesN_few": "{{count}} zgłoszenia",
                "entriesN_many": "{{count}} zgłoszeń",
                "pointsN_one": "1 punkt",
                "pointsN_few": "{{count}} punkty",
                "pointsN_many": "{{count}} punktów",
                "Wait for others": "Poczekaj na innych",
                "Join": "Dołącz",
                "Leave": "Opuść",
                "Your username": "Twoja nazwa użytkownika",
                "Create table": "Utwórz stół",
                "Delete table": "Usuń stół",
                "Create New Table": "Utwórz nowy stół",
                "Game": "Gra",
                "Notes": "Notatki",
                "Your proposition": "Twoja propozycja",
                "Game Tables": "Stoły",
                "Players": "Gracze",
                "Name updated successfully": "Pomyślnie zmieniono nazwę",
                "Table created successfully": "Stworzono stół",
                "Table deleted successfully": "Pomyślnie usunięto stół",
                "Please select a game": "Proszę wybrać grę",
                "No players": "Brak graczy",
                "You must set your name first": "Musisz najpierw ustawić swoją nazwę",
                "Enter new name": "Wpisz nową nazwę",
                "+week": "+tydzień",
                "Saved": "Zapisano",
                "SavedN_zero":"Zapisano 0 gier",
                "SavedN_one":"Zapisano 1 grę",
                "SavedN_few":"Zapisano {{count}} gry",
                "SavedN_many":"Zapisano {{count}} gier",                
                "SavedN_other":"Zapisano {{count}} gier",
                "Propositions": "Propozycje",
                "Preferences": "Preferencje",
                "Results": "Wyniki"
            }
        }
    }
  });

export default i18n;
